<template>
  <router-view />
</template>

<script>

export default {
  mounted() {  
    let user = localStorage.getItem("user");
    user = user ? JSON.parse(user) : {};

    this.$vuetify.theme.themes.light.primary = user.theme_primary_color ? user.theme_primary_color : '#f87676';
    this.$vuetify.theme.themes.dark.primary = user.theme_primary_color ? user.theme_primary_color : '#f87676';
    this.$vuetify.theme.themes.light.secondary = user.theme_button_color ? user.theme_button_color : '#30384d';
    this.$vuetify.theme.themes.dark.secondary = user.theme_button_color ? user.theme_button_color : '#30384d';
  }
}
</script>
<style>
/* tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
} */
.v-data-table tbody tr:hover td {
  background-color: #f5f5f5 !important;
  cursor: pointer;
}
.v-text-field {
  margin-top: 5px !important;
  padding-top: 5px !important;
}
/* .v-data-table-header th.active {
  color: rgba(0, 0, 0, 0.6) !important;
}
.v-data-table-header th.active .v-data-table-header__icon {
  color: rgba(0, 0, 0, 0.6) !important;
} */
</style>